import React from 'react';

type RefType<T> = React.RefCallback<T> | React.RefObject<T> | null | undefined;

/**
 * Merge multiple references assigned to an element
 *
 * Based on https://github.com/facebook/react/issues/8873#issuecomment-275423780
 *
 * @params {RefType<T>[]} refs - List of refs to merge
 * @return {React.RefCallback<T>} Combined ref callback
 */
export default function mergeRefs<T = HTMLElement>(
  refs: RefType<T>[] = []
): React.RefCallback<T> {
  return (value: T | null) => {
    refs.forEach(ref => {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref != null) {
        // @ts-expect-error - assignment
        // eslint-disable-next-line no-param-reassign
        ref.current = value;
      }
    });
  };
}
